import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Privacy from "../pages/privacy/page";
import Hipaa from "../pages/hipaa/page";
import Terms from "../pages/terms/page";
import ThankYou from "../pages/thank-you/page";

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/hipaa-notice',
    element: <Hipaa />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/thank-you',
    element: <ThankYou />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;